module.exports = __webpack_public_path__ + "static/pokoj-nr3-photo01-nikon-1641c3f0780f68f8926cd2de5d6794ad.jpg";